
import Vue from 'vue'
import { IconSearch } from '@/components/svg'
import { ProductItem } from '@/components/product'
import { ArticleItem } from '@/components/article'

export default Vue.extend({
    metaInfo() {
        return {
            title: "Search | BOBU AFRICA",
            link: [
                { rel: "canonical", href: `${window.location.href}` }
            ],
            meta: [
                { name: 'description', content: 'Search | BOBU AFRICA' },
                { property: "og:type", content: "website" },
                { property: "og:url", content: `${window.location.href}` },
                { property: "og:title", content: "Search | BOBU AFRICA" },
                { property: "og:description", content: "Search | BOBU AFRICA" },
                { property: "og:image", content: "https://static.bobuafrica.com/loading.webp" },
                { property: "twitter:card", content: "summary_large_image" },
                { property: "twitter:url", content: `${window.location.href}` },
                { property: "twitter:title", content: "Search | BOBU AFRICA" },
                { property: "twitter:description", content: "Search | BOBU AFRICA" },
                { property: "twitter:image", content: "https://static.bobuafrica.com/loading.webp" },
            ]
        }
    },
    components: { IconSearch, ProductItem, ArticleItem },
    data() {
        return {
            form: {
                _q: this.$route.query.q || ''
            },
            products: [],
            articles: []
        }
    },
    computed: {
        activeTab: {
            get(): 'products' | 'articles' {
                return (this.$route.query.type as 'products' | 'articles') || 'products'
            },
            set(type: 'products' | 'articles') {
                this.$router.replace({ query: { ...this.$route.query, type } })
            }
        },
        queryValue(): string {
            // Ensure form is initialized before getting the field value
            return this.form._q || ''
        },
        showFilter(): boolean {
            // Show filter only if queryValue is not empty
            return this.queryValue.trim() !== ''
        }
    },
    watch: {
        queryValue: '_q',
        activeTab: 'search'
    },
    mounted() {
        this.search()
    },
    methods: {
        async search() {
            let collection = ''
            let fields = ''

            if (this.activeTab === 'products') {
                collection = 'product'
                fields = '*,translations.*'
            } else if (this.activeTab === 'articles') {
                collection = 'article'
                fields = '*,translations.*'
            }

            try {
                const response = await this.$axios.get(`/${collection}`, {
                    params: {
                        fields,
                        'deep[translations][_filter][languages_code][_eq]': this.$i18n.locale,
                    }
                })

                this[this.activeTab] = response.data.data
            } catch (error) {
                console.error('Search error:', error)
            }
        }
    }
})
